if (!customElements.get("fabric-details")) {
  class a extends HTMLElement {
    constructor() {
      (super(),
        (this.selectors = {
          trigger: document.querySelectorAll(
            '[aria-controls*="drawer-fabric-details"]',
          ),
          content: this.querySelector("[data-content]"),
        }),
        this.selectors.trigger.forEach((e) => {
          e.addEventListener("click", () => {
            e.dataset.handle && this.fetchDetails(e.dataset.handle);
          });
        }),
        // Colours of the same family are injected with the content, so the click has to
        // be delegated instead of bound per element.
        this.selectors.content.addEventListener("click", (event) => {
          const color = event.target.closest("[data-fabric-handle]");
          if (color) this.fetchDetails(color.dataset.fabricHandle);
        }));
    }
    fetchDetails(e) {
      ((this.selectors.content.innerHTML = ""),
        this.classList.add("loading"),
        fetch(`/pages/fabrics/${e}?view=details`, { method: "GET" })
          .then((e) => e.text())
          .then((e) => {
            e = new DOMParser().parseFromString(e, "text/html");
            ((this.selectors.content.innerHTML =
              e.querySelector("[data-content]").innerHTML),
              this.selectors.content.querySelectorAll("video").forEach((v) => {
                v.muted = true;
                v.play();
              }),
              setTimeout(() => {
                this.classList.remove("loading");
              }, 300));
          }));
    }
  }
  customElements.define("fabric-details", a);
}
